import axios, { AxiosResponse } from 'axios'

export const getScannerData = async (formData: FormData) => {
  const res: AxiosResponse = await axios({
    method: 'post',
    url: process.env.BASE_URL_SCANNER,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return res
}
